'use client';

import { CardAppointmentRealizedByType } from './card-appointment-realized-by-type.component';
import { CardAppointmentScheduled } from './variants/card-appointment-scheduled.component';
import { CardAppointmentFlex } from './variants/card-appointment-flex.component';
import { CardAppointmentArrivalOrder } from './variants/card-appointment-arrival-order.component';
import { CardAppointmentTelemed } from './variants/card-appointment-telemed.component';
import { CardAppointmentStandalone } from './variants/card-appointment-standalone.component';
import { CardAppointmentLab } from './variants/card-appointment-lab.component';

import { ScheduleType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { Appointment } from '@/types/appointments.types';
import { AppointmentMode, AppointmentType } from '@/types/enums/appointments.enum';

export interface CardAppointmentProps {
  appointment: Appointment;
  defaultOpen?: boolean;
  onAppointmentUpdate: (appointment: Partial<Appointment>) => void;
}

export default function CardAppointment({
  appointment,
  defaultOpen = true,
  onAppointmentUpdate,
}: CardAppointmentProps) {
  if (appointment.hasFinished) {
    return <CardAppointmentRealizedByType appointment={appointment} defaultOpen={defaultOpen} />;
  }

  if (appointment.mode === AppointmentMode.STANDALONE) {
    return (
      <CardAppointmentStandalone
        appointment={appointment}
        defaultOpen={defaultOpen}
        onAppointmentUpdate={onAppointmentUpdate}
      />
    );
  }

  if (appointment.type === AppointmentType.LABORATORIAL) {
    return (
      <CardAppointmentLab
        appointment={appointment}
        defaultOpen={defaultOpen}
        onAppointmentUpdate={onAppointmentUpdate}
      />
    );
  }

  if (appointment.isTelehealth) {
    return (
      <CardAppointmentTelemed
        appointment={appointment}
        defaultOpen={defaultOpen}
        onAppointmentUpdate={onAppointmentUpdate}
      />
    );
  }

  if (appointment.scheduleType === ScheduleType.ARRIVAL_ORDER) {
    return (
      <CardAppointmentArrivalOrder
        appointment={appointment}
        defaultOpen={defaultOpen}
        onAppointmentUpdate={onAppointmentUpdate}
      />
    );
  }

  if (appointment.scheduleType === ScheduleType.FLEX && !appointment.date) {
    return (
      <CardAppointmentFlex
        appointment={appointment}
        defaultOpen={defaultOpen}
        onAppointmentUpdate={onAppointmentUpdate}
      />
    );
  }

  return (
    <CardAppointmentScheduled
      appointment={appointment}
      defaultOpen={defaultOpen}
      onAppointmentUpdate={onAppointmentUpdate}
    />
  );
}
